import {applicationAPI} from '@/api/requesters/application';

const useApplicationControllerHook = () => {
  const api = applicationAPI.clone();

  return {
    ...api,
  };
};

export const applicationController = useApplicationControllerHook();
